import { Object, Optional, Static, String } from '@sinclair/typebox';

export type ExtendSessionRequest = Static<typeof ExtendSessionRequest>;
export const ExtendSessionRequest = Object({
  sessionId: Optional(String()),
});

export type ExtendSessionResponse = Static<typeof ExtendSessionResponse>;
export const ExtendSessionResponse = Object({
  sessionId: String(),
});
